// extracted by mini-css-extract-plugin
export default {"Flex":"styles_Flex__mEcp1","Flex-item":"styles_Flex-item__Spn2q"};